import { render, staticRenderFns } from "./funds.vue?vue&type=template&id=da249c56&scoped=true&"
import script from "./funds.vue?vue&type=script&lang=js&"
export * from "./funds.vue?vue&type=script&lang=js&"
import style0 from "./funds.vue?vue&type=style&index=0&id=da249c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da249c56",
  null
  
)

export default component.exports